<button type="button" class="btn btn-success btn-excel {{className}}" (click)="export()">
  Exportar a Excel
</button>